import { render } from "./userShortcut.vue?vue&type=template&id=5675b0dc"
import script from "./userShortcut.vue?vue&type=script&lang=js"
export * from "./userShortcut.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__